import React, { useEffect, useState } from 'react';
import '../../assets/scss/page/diagnostic-page-style.scss';
import FooterComponent from '../../component/base/footer-component/FooterComponent';
import { getFlight, getPanasonicLog } from '../../store/FlightStore';
import parse from 'html-react-parser';
import { checkBackend, checkWhiteList } from '../../util/HealthCheck';
import Const from '../../constant/Const';
import OnboardPassword from '../../component/base/onboard-password/OnboardPassword';
import OnboardButton from '../../component/base/onboard-button-component/OnboardButton';
import logo from 'assets/images/turkish_technic.svg';
import { useRecoilValue } from 'recoil';
import { connectionErrorAtom } from '../../store/ConnectionErrorStore';
import HeaderSimpleComponent from '../../component/base/header-component/HeaderSimpleComponent';

const DiagnosticPage = (props) => {
    const {t, navigate} = props.props;
    const [show, setShow] = useState(false);
    const [password, setPassword] = useState(null);
    const [error, setError] = useState(null);
    const [resultInternetAccess, setResultInternetAccess] = useState(0);
    const [resultWhiteListAccess, setResultWhiteListAccess] = useState(0);
    const [resultBackendAccess, setResultBackendAccess] = useState(0);
    const [showLine, setShowLine] = useState(7);
    const connectionError = useRecoilValue(connectionErrorAtom);

    const validation = () => {
        if (password === 'THY123' || password === 'IFE123' || password === 'thy123' || password === 'ife123' || password === 'İFE123') setShow(true);
        else setError(t('error.login_other_pass_failed'))
    }

    useEffect(() => {
        const fetchData = async api => {
            setResultWhiteListAccess(await checkWhiteList());
            setResultBackendAccess(await checkBackend());
        };
        fetchData();
    }, [])

    const renderPanasonicLogs = () => {
        return getPanasonicLog().reverse().map((value, index) => {
            if (index >= showLine) return;
            return (
                <tr key={index} className="diagnostic-detail">
                    <td className="diagnostic-detail-number">{index + 1}</td>
                    <td className="diagnostic-detail-date">{parse(new Date(value.localDate).toLocaleString().replace(",", ""))}</td>
                    <td>{value.service}</td>
                    <td className={value.error ? 'diagnostic-detail-error' : ''}>{value.message.indexOf('{') === 0 ? JSON.stringify(JSON.parse(value.message), null, "\t") : value.message}</td>
                </tr>
            );
        })
    }

    const getInfoRender = () => {
        return show ? (<div>
            <table className="diagnostic-table">
                <tbody>
                <tr>
                    <td>IP</td>
                    <td>{getFlight()?.clientIp === null ? '-' : getFlight()?.clientIp}</td>
                </tr>
                <tr>
                    <td>MAC</td>
                    <td>{getFlight()?.macId === null ? '-' : getFlight()?.macId}</td>
                </tr>
                <tr>
                    <td>{t('diagnostic.loadable_version')}</td>
                    <td>{"v" + process.env.REACT_APP_VERSION}</td>
                </tr>
                <tr>
                    <td>{t('diagnostic.panasonic_connect_enable')}</td>
                    <td>{parse(!connectionError ?
                        `<span className="diagnostic-status-active">${t('diagnostic.active')}</span>` :
                        `<span className="diagnostic-status-passive">${t('diagnostic.passive')}</span>`)}</td>
                </tr>
                <tr>
                    <td>{t('diagnostic.backend_connect_enable')}</td>
                    <td>{parse(resultBackendAccess === 0 ? `<span>${t('please_wait')}</span>` :
                        resultBackendAccess ? `<span className="diagnostic-status-active">${t('diagnostic.active')}</span>` :
                            `<span className="diagnostic-status-passive">${t('diagnostic.passive')}</span>`)}</td>
                </tr>
                <tr>
                    <td>{t('diagnostic.whitelist_enable')}</td>
                    <td>{parse(resultWhiteListAccess === 0 ? `<span>${t('please_wait')}</span>` :
                        resultWhiteListAccess ? `<span className="diagnostic-status-active">${t('diagnostic.active')} 
                                <span className="diagnostic-status-hint">(${Const.TURKISH_AIRLINES_URL})</span></span>` :
                            `<span className="diagnostic-status-passive">${t('diagnostic.passive')}</span>`)}</td>
                </tr>
                <tr>
                    <td>{t('diagnostic.internet_enable')}</td>
                    <td>{parse(resultInternetAccess === 0 ? `<span>${t('please_wait')}</span>` :
                        resultInternetAccess ?
                            `<span className="diagnostic-status-active">${t('diagnostic.active')}</span>` :
                            `<span className="diagnostic-status-passive">${t('diagnostic.passive')}</span>`)}</td>
                </tr>
                </tbody>
            </table>
            <h3>{t('diagnostic.panasonic_status')}</h3>
            <table className="diagnostic-detail-table">
                <thead>
                <tr>
                    <td className="diagnostic-detail-number">#</td>
                    <td className="diagnostic-detail-date">{t('diagnostic.date')}</td>
                    <td>{t('diagnostic.service')}</td>
                    <td>{t('diagnostic.status')}</td>
                </tr>
                </thead>
                <tbody>
                {renderPanasonicLogs()}
                </tbody>
            </table>
        </div>) : (<div></div>);
    }

    return (
        <div>
            <HeaderSimpleComponent title={t('diagnostic.title')}/>

            <div className="content-root">

                {!show && (
                    <div className="diagnostic-detail-password">

                        <img className="diagnostic-detail-logo" alt="Turkish Technic" src={logo}/>

                        <OnboardPassword placeholder={t('login.password')}
                                         onChange={(e) => {
                                             setError(null);
                                             setPassword(e)
                                         }}
                                         error={error} isNotNumber
                                         value={password}/>

                        <div className="h-16"></div>

                        <OnboardButton label={t('login.login_btn')} onClick={() => validation()}/>

                    </div>
                )}

                {getInfoRender()}

                {show && (
                    <p className="diagnostic-detail-more-less" onClick={() => {
                        if (showLine === 7) setShowLine(50);
                        else setShowLine(7);
                    }}>{showLine === 7 ? t('diagnostic.table_more') : t('diagnostic.table_less')}</p>)
                }

                <p onClick={() => navigate(-1)} className="cancel">{t('return_home')}</p>

            </div>

            <FooterComponent/>

        </div>
    );
};

export default DiagnosticPage;

